/*a component that is used to add fields to a form. */
import React, { Component } from "react"
import fieldMap from "../../DynamicForm/Fields/FieldMap"
import FieldTypes from "../../Types/FieldTypes"
import fieldIcons from "../../Utils/FieldIcons"
import schemaBoiler from "../../Utils/SchemaBoiler"
import stateMutator from "../../Utils/StateMutator"
import "./DynamicFormFieldManager.css"

interface Props {
    manageParentState: Function
    addOrRemoveColumn: Function
    addOrRemoveRow: Function
    highlightTarget: { row: number, col: number }
    mouseInFieldManager: boolean
    template: Array<Array<FieldTypes>>
}

interface State {
    menuMarginTop: number
}

class DynamicFormFieldManager extends Component<Props, State>{

    defaultMenuTopMargin = -60
    HoverTimeout = 0

    state = {
        menuMarginTop: this.defaultMenuTopMargin
    }

    componentDidMount() {
        document.addEventListener("keyup", this.handleKeyPress)
    }

    /* A function that is used to update the state. It is used to prevent the state from being updated in
    an uncontrolled manner. */
    manageState = (keys: Array<{ key: string, value?: any }>) => {
        this.setState(stateMutator.mutate(this.state, keys))
    }

    handleKeyPress = (event: { key: string | null }) => {
        const key = this.props.mouseInFieldManager? event.key : null
        if (key === "r") {
            this.props.addOrRemoveRow(-1)
        }
        if (key === "c" && this.props.highlightTarget.row > -1) {
            this.addEmptyColumn(this.props.highlightTarget.row)
        }
    }

    addEmptyColumn = (row: number) => {
        let template = this.props.template
        if (template[row].length < 4) {
            template[row].push(schemaBoiler)
            template = template.filter(function (element: any) { return element !== undefined })
            this.props.manageParentState([{ key: "template", value: template }], true)
        }
    }

    /* A function that is used to show or hide an element. It is used to show or hide the menu that is used
    to add fields to the form. */
    showOrHide = (show: boolean, element: string | null, highlightTarget: { row: number, col: number }, attentionDex?: number | null) => {
        const display = show ? "block" : "none"
        const row = highlightTarget.row
        const col = highlightTarget.col
        const srollToElement = document.getElementById(`dynamic-form-template-row-${row}`)
        if (element) {
            let elem = document.getElementById(element)
            //@ts-ignore
            elem.style.display = display
        }
        if (srollToElement) {
            //@ts-ignore
            srollToElement.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" })
        }
        if (show && row === -1 && col === -1) {
            this.manageState([{ key: "menuMarginTop", value: this.defaultMenuTopMargin }])
        }

        if (attentionDex) {
            for (let i = 0; i < fieldMap.fields.length; i++) {
                let elem = document.getElementById(`dynamic-form-field-manager-item-${i}`)
                if (elem && attentionDex !== i) {
                    elem.style.outline = "none"
                } else if (elem && attentionDex === i) {
                    elem.style.outline = "2px solid #007bff"
                    elem.style.backgroundColor = "#595959"
                    elem.style.color = "#FFFFFF"
                }
            }
        }

        if (!show) {
            for (let i = 0; i < fieldMap.fields.length; i++) {
                let elem = document.getElementById(`dynamic-form-field-manager-item-${i}`)
                if (elem) {
                    elem.style.outline = "none"
                    elem.style.backgroundColor = "#efefef"
                    elem.style.color = "#000000"
                }
            }
        }
        this.props.manageParentState([{ key: "highlightTarget", value: highlightTarget }, { key: "mouseInFieldManager", value: show }])
    }

    /* A function that takes in an event and an element. It then gets the element by its id. It then sets
    the step to -25 or 25 depending on the direction of the scroll. It then sets the margin to the
    current margin plus the step. It then sets the state of the component. It then sets the margin of
    the element to the margin. */
    scroll = (event: any, element: any) => {
        let elem = document.getElementById(element)
        const step = event.deltaY > 0 ? -25 : 25
        const margin = this.state.menuMarginTop + step
        this.manageState([{ key: "menuMarginTop", value: margin }])
        if (elem) {
            elem.style.marginTop = `${margin}px`
        }
    }

    render() {

        const props = this.props
        const state = this.state
        let template = props.template

        return (
            <div className="DynamicFormFieldManager">
                {fieldMap.fields.map((field, i: number) =>
                    <div className={`DynamicFormFieldManagerItemWrapper DynamicFormFieldManagerItemWrapper${field.type.replace(/ /g, '')}`}
                        id={`dynamic-form-field-manager-item-wrapper-${i}`}
                        key={`dynamic-form-field-manager-item-wrapper-${i}`}>
                        <div className="DynamicFormFieldManagerItem"
                            id={`dynamic-form-field-manager-item-${i}`}
                            onMouseEnter={() => this.showOrHide(true, `dynamic-form-field-manager-item-menu-${i}`, { row: -1, col: -1 }, i)}
                            onMouseLeave={() => this.showOrHide(false, `dynamic-form-field-manager-item-menu-${i}`, { row: -1, col: -1 }, i)}>
                            <div className="DynamicFormFieldManagerItemHeader">
                                <p>{field.type}</p>
                            </div>
                            <span id={`dynamic-form-field-manager-${field.configHelper.fieldType}-icon`} className="material-icons">{fieldIcons.getIcon(field.type)?.icon}</span>
                            {fieldIcons.getIcon(field.type)?.text && <p id={`dynamic-form-field-manager-${field.configHelper.fieldType}-text`}>{fieldIcons.getIcon(field.type)?.text}</p>}
                        </div>
                        <div
                            id={`dynamic-form-field-manager-item-menu-${i}`}
                            style={{ marginTop: `${state.menuMarginTop}px` }}
                            className="DynamicFormFieldManagerItemMenu"
                            onMouseEnter={() => this.showOrHide(true, `dynamic-form-field-manager-item-menu-${i}`, { row: -1, col: -1 })}
                            onMouseLeave={() => this.showOrHide(false, `dynamic-form-field-manager-item-menu-${i}`, { row: -1, col: -1 })}
                            onWheel={(e) => this.scroll(e, `dynamic-form-field-manager-item-menu-${i}`)}
                        >
                            <div className="DynamicFormFieldManagerItemMenuRowColSelector">
                                {template.map((row, j: number) =>
                                    <div
                                        className="DynamicFormFieldManagerItemMenuRowColSelectorRowItem"
                                        key={`dynamic-form-field-manager-item-menu-row-col-selector-row-item-${j}`}
                                        onMouseEnter={() => this.showOrHide(true, `dynamic-form-field-manager-item-menu-row-col-selector-col-items-${j}`, { row: j, col: -1 }, i)}
                                        onMouseLeave={() => this.showOrHide(false, `dynamic-form-field-manager-item-menu-row-col-selector-col-items-${j}`, { row: -1, col: -1 }, i)}
                                        onClick={field.configHelper.fieldType === "signature" ? () => props.addOrRemoveColumn(field.type, j, 0) : () => null}
                                    >
                                        <p>{`Row ${j + 1}`}</p>
                                        <div
                                            id={`dynamic-form-field-manager-item-menu-row-col-selector-col-items-${j}`}
                                            className="DynamicFormFieldManagerItemMenuRowColSelectorColItems">
                                            {row.map((col, k: number) =>
                                                <div className="DynamicFormFieldManagerItemMenuRowColSelectorColItem"
                                                    key={`dynamic-form-field-manager-item-menu-row-col-${k}`}
                                                    onMouseEnter={() => this.showOrHide(true, null, { row: j, col: k }, i)}
                                                    onMouseLeave={() => this.showOrHide(true, null, { row: j, col: -1 }, i)}>
                                                    <div className="DynamicFormFieldManagerItemMenuRowColSelectorColItemAdd"
                                                        onClick={() => props.addOrRemoveColumn(field.type, j, k)}>
                                                        <p>{`Col ${k + 1}`}</p>
                                                    </div>
                                                </div>)}
                                        </div>
                                    </div>)}
                            </div>
                        </div>
                    </div>)}
            </div>
        )
    }
}

export default DynamicFormFieldManager